import APIService from "@/services/APIService.js";

const apiMunic = APIService.create({
  baseURL: process.env.VUE_APP_API_URL + "/admin/munic"
});

export default {
  getAll(limit, page, filters) {
    return apiMunic.get("", {
      params: {
        limit: limit,
        offset: page * limit - limit,
        sort_by: "nom_munic",
        ...filters
      }
    });
  },
};
